import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { FormattedMessage, intlShape } from "react-intl";

import * as actions from "./enumActions";

class EnumWrapper extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.getEnums = this.getEnums.bind(this);
    this.isReady = this.isReady.bind(this);
    this.format = this.format.bind(this);
  }

  componentDidMount() {
    this.getEnums(this.props).map((wantedEnum) =>
      this.props.actions.getEnum(
        wantedEnum.name,
        wantedEnum.query,
        this.props.state.enums
      )
    );
  }

  componentWillUpdate(nextProps) {
    const currentEnums = this.getEnums(this.props);
    const nextEnums = this.getEnums(nextProps);
    currentEnums.map((currentEnum) => {
      const nextEnum = nextEnums.find(
        (nextEnum) => nextEnum.name == currentEnum.name
      );
      if (nextEnum && nextEnum.query != currentEnum.query) {
        this.props.actions.getEnum(
          nextEnum.name,
          nextEnum.query,
          this.props.state.enums
        );
      }
    });
  }

  isReady() {
    return this.getEnums(this.props).every(
      (wantedEnum) =>
        this.props.state.enums[wantedEnum.name] &&
        this.props.state.enums[wantedEnum.name].loaded &&
        (!wantedEnum.query ||
          this.props.state.enums[wantedEnum.name].query == wantedEnum.query)
    );
  }

  getEnums(props) {
    if (props.enum) {
      return [
        {
          ...props.enum,
          format: props.format,
          prop: props.prop,
          query: props.query,
        },
      ];
    }
    return props.enums;
  }

  format(wantedEnum) {
    const { values } = this.props;
    switch (wantedEnum.format) {
      case "inputs": {
        return this.props.state.enums[wantedEnum.name].items
            .filter((item) =>
                values ? values.includes(item[wantedEnum.identifier]) : true
            )
            .map((item) => {
                return {
                    value: item[wantedEnum.identifier],
                    text: item.localizations[this.context.intl.locale].name,
                };
            });
      }
      default: {
        return this.props.state.enums[wantedEnum.name].items;
      }
    }
  }

  render() {
    if (!this.isReady()) {
      return (
        (this.props.showLoading && (
          <span>
            <FormattedMessage id="common.loading" />
          </span>
        )) ||
        null
      );
    }
    const componentProps = this.getEnums(this.props).reduce(
      (data, wantedEnum) => {
        data[wantedEnum.prop || wantedEnum.name] = this.format(wantedEnum);
        return data;
      },
      { wantedEnum: this.props.enum }
    );
    return (
      <div>
        {React.cloneElement(this.props.children, { ...componentProps })}
      </div>
    );
  }
}

EnumWrapper.propTypes = {
  actions: PropTypes.object,
  enum: PropTypes.object,
  enums: PropTypes.array,
  format: PropTypes.string,
  prop: PropTypes.string,
  state: PropTypes.object,
  children: PropTypes.node,
  showLoading: PropTypes.bool,
  values: PropTypes.array,
};

EnumWrapper.contextTypes = {
  intl: intlShape,
};

EnumWrapper.defaultProps = {
  showLoading: true,
};

function mapStateToProps(state) {
  return {
    state: state,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EnumWrapper);



// WEBPACK FOOTER //
// ./src/utils/enums/EnumWrapper.js